import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get Courses
export const ListCourse = createAsyncThunk('course-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/course/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Course
export const createCourse = createAsyncThunk('course-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/course/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Course id
export const editCourse = createAsyncThunk('course-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/course/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Course
export const deleteCourse = createAsyncThunk('course-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/course/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// View Course
export const viewCourse = createAsyncThunk('course-view', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/course/view/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Course Lessons
export const listCourseLessons = createAsyncThunk(
  'course-lesson-list',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/course-lesson/list/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const listCourseSessionLessons = createAsyncThunk(
  'course-lesson-list-by-session',
  async ({id, lesson_number}: {id: string; lesson_number: number}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/course-lesson/list-by-lesson/${id}/${lesson_number}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Course Lesson
export const createCourseLesson = createAsyncThunk(
  'course-lesson-create',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/course-lesson/store', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete CourseLesson
export const deleteCourseLesson = createAsyncThunk(
  'course-lesson-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/course-lesson/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete CourseLesson
export const toggleCourseLesson = createAsyncThunk(
  'course-lesson-toggle',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/course-lesson/toggle-visibility/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get PublicationCategory
export const ListPublicationCategory = createAsyncThunk(
  'publication-category-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/publication-category/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create PublicationCategory
export const createPublicationCategory = createAsyncThunk(
  'publication-category-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/publication-category/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get PublicationCategory id
export const editPublicationCategory = createAsyncThunk(
  'publication-category-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/publication-category/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete PublicationCategory
export const deletePublicationCategory = createAsyncThunk(
  'publication-category-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/publication-category/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get PublicationField
export const ListPublicationField = createAsyncThunk(
  'publication-field-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/publication-field/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create PublicationField
export const createPublicationField = createAsyncThunk(
  'publication-field-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/publication-field/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get PublicationField id
export const editPublicationField = createAsyncThunk(
  'publication-field-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/publication-field/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete PublicationField
export const deletePublicationField = createAsyncThunk(
  'publication-field-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/publication-field/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get publications
export const ListPublication = createAsyncThunk(
  'publication-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/publication/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create publication
export const createPublication = createAsyncThunk(
  'publication-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/publication/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get publication id
export const editPublication = createAsyncThunk(
  'publication-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/publication/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete publication
export const deletePublication = createAsyncThunk(
  'publication-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/publication/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// getAuthors
export const getAuthors = createAsyncThunk('get-authors', async (type: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/publication/get-author/${type}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Toggle Publication
export const togglePublication = createAsyncThunk(
  'publication-toggle',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/publication/toggle/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// rate Publication
export const ratePublication = createAsyncThunk<
  any,
  {id: string; rate: string},
  {rejectValue: {errors: string[]}}
>('publication-rating', async ({id, rate}, thunkAPI) => {
  try {
    const res = await axios.get(`/api/publication/rating/${id}/${rate}`)
    return res.data
  } catch (error: any) {
    if (error.response && error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get VideoLibrarys
export const ListVideoLibrary = createAsyncThunk(
  'video-library-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/video-library/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create VideoLibrary
export const createVideoLibrary = createAsyncThunk(
  'video-library-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/video-library/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get VideoLibrary id
export const editVideoLibrary = createAsyncThunk(
  'video-library-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/video-library/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete VideoLibrary
export const deleteVideoLibrary = createAsyncThunk(
  'video-library-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/video-library/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Toggle VideoLibrary
export const toggleVideoLibrary = createAsyncThunk(
  'video-library-toggle',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/video-library/toggle/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create emailToRelatedStudents
export const emailToRelatedStudents = createAsyncThunk(
  'email-to-related-students',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/campus-faculty/email', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListTimeTable = createAsyncThunk('timetable-list', async (lang: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/timetable/list/${lang}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteTimeTableCourse = createAsyncThunk(
  'timetable-course-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/timetable/destroy-course/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTimeTableCourse = createAsyncThunk(
  'timetable-course-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/timetable/store-course', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editTimeTableCourse = createAsyncThunk(
  'timetable-course-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/edit-course/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteTimeTableProgram = createAsyncThunk(
  'timetable-program-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/timetable/destroy-program/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTimeTableProgram = createAsyncThunk(
  'timetable-program-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/timetable/store-program', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editTimeTableProgram = createAsyncThunk(
  'timetable-program-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/edit-program/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteTimeTableSemester = createAsyncThunk(
  'timetable-semester-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/timetable/destroy-semester/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTimeTableSemester = createAsyncThunk(
  'timetable-semester-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/timetable/store-semester', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editTimeTableSemester = createAsyncThunk(
  'timetable-semester-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/edit-semester/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/timetable/destroy-schedule/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/timetable/store-schedule', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editTimeTableSchedule = createAsyncThunk(
  'timetable-schedule-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/edit-schedule/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const toggleCourse = createAsyncThunk('course-toggle', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/timetable/toggle/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const toggleProgram = createAsyncThunk('program-toggle', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/timetable/program-toggle/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AddStudentToCourse = createAsyncThunk('add-student', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/timetable/add-student', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListCourseStudents = createAsyncThunk(
  'course-students-list',
  async ({target_type, target_id}: {target_type: string; target_id: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/stduents-list/${target_type}/${target_id}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteStudentCourse = createAsyncThunk(
  'student-course-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/timetable/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CourseStudentsDelete = createAsyncThunk(
  'students-course-delete',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post(`/api/timetable/destroy-course-students`, data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetLecturers = createAsyncThunk('get-lecturers', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/timetable/get-lecturers`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const TimeTablePrint = createAsyncThunk('timetable-print', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/timetable/print/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ApproveStudentScore = createAsyncThunk(
  'approve-students-score',
  async ({target_id, target_type}: {target_id: string; target_type: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/approve-score/${target_id}/${target_type}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintStdAttendance = createAsyncThunk(
  'student-att-print',
  async ({courseId, type}: {courseId: string; type: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/att-print/${courseId}/${type}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CourseEvReport = createAsyncThunk(
  'course-ev-report',
  async ({tarId, tarType}: {tarId: string; tarType: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/course-ev-report/${tarId}/${tarType}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const PrintCourseEvReport = createAsyncThunk(
  'course-ev-print',
  async ({tarId, tarType}: {tarId: string; tarType: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/timetable/course-ev-print/${tarId}/${tarType}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EvReportExcel = createAsyncThunk('ev-report-excel', async (id: string) => {
  const response = await axios.get(`/api/timetable/ev-report-excel/${id}`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'Evaluation_Report.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const UpdateTimeSlot = createAsyncThunk('update-timeslot', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/timetable/update-timeslot', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyStudents = createAsyncThunk('get-ay-stds', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/timetable/get-ay-stds/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyProStds = createAsyncThunk('getAyProStds', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/timetable/get-pro-ay-stds', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ProgramPrint = createAsyncThunk('program-print', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/timetable/program-print/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetLessonTitles = createAsyncThunk('course-titles', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/course-lesson/list-course-titles/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createCourseTitle = createAsyncThunk(
  'course-title-create',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`/api/course-lesson/store-course-title`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createCourseLes = createAsyncThunk('course-les-create', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/course-lesson/store-course-material`, data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AyStudents = createAsyncThunk('ay-students', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/timetable/ay-students/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AssignPeerEv = createAsyncThunk(
  'assign-peer-evaluation',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/timetable/assign-peer-evaluation', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getAttRepType = createAsyncThunk('att-report-type', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/ac-reps/att-report-type/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AttReport = createAsyncThunk('att-report', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/ac-reps/att-report', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AttReportPrint = createAsyncThunk('att-report-print', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/ac-reps/att-report-print', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AttReportPrintExcel = createAsyncThunk(
  'att-report-excel',
  async (formData: FormData) => {
    const response = await axios.post('/api/ac-reps/att-report-excel', formData, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'AttendanceReport.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const PrintCourseAtt = createAsyncThunk('att-print', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/ac-reps/att-print', data)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ExportCourseAtt = createAsyncThunk('att-excel', async (data: {}) => {
  const response = await axios.post(`/api/ac-reps/att-excel`, data, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'AttendanceReport.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

export const getScoreRepType = createAsyncThunk('score-rep-type', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/ac-reps/score-report-type/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const scoreReport = createAsyncThunk('score-report', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/ac-reps/score-report', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ScoreReportPrint = createAsyncThunk(
  'score-report-print',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/ac-reps/score-report-print', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const scoreReportExcel = createAsyncThunk(
  'score-report-excel',
  async (formData: FormData) => {
    const response = await axios.post('/api/ac-reps/score-report-excel', formData, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'ScoreReport.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const PrintCourseScore = createAsyncThunk('score-print', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/ac-reps/score-print', data)
    return response.data
  } catch (error: any) {
    if (error.response?.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ExportCourseScore = createAsyncThunk('score-excel', async (data: {}) => {
  const response = await axios.post(`/api/ac-reps/score-excel`, data, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'ScoreReport.xlsx')
  document.body.appendChild(link)
  link.click()
  link.remove()
})

type AcademicsState = {
  record: any
  records: any
  errors: any
}

const initialState: AcademicsState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const academicSlice = createSlice({
  name: 'academic',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListCourse.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(listCourseLessons.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(ListPublicationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublicationCategory.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListPublicationField.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublicationField.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListPublication.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createPublication.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListVideoLibrary.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createVideoLibrary.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(emailToRelatedStudents.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListTimeTable.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
  },
})

export const {reset} = academicSlice.actions
export default academicSlice.reducer
